import { useEffect, useState, useCallback } from 'react'
import { getWeb3 } from '../../utils/web3'
import { useActiveWeb3React } from '../'

const useNodeBlock = () => {
  const [block, setBlock] = useState(0)
  const { account, chainId, library } = useActiveWeb3React()
  const ethereum = library?.provider

  const blockInterval = useCallback(async () => {
    if (!ethereum || !account) return
    const web3 = getWeb3(chainId as number)
    const latestBlockNumber = await web3.eth.getBlockNumber()
    if (latestBlockNumber >= block) {
      setBlock(latestBlockNumber)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, ethereum, chainId, block])

  useEffect(() => {
    blockInterval()
    let refreshInterval = setInterval(blockInterval, 1000)
    return () => clearInterval(refreshInterval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [block])

  return block
}

export default useNodeBlock
